import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useState } from 'react'
import { nextPage } from 'components/RCPro/helpers/nav'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { formatNb } from 'functions'
import style from './Frequency.module.scss'

const RCProEstimate = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const { nextPageTransition } = useOutletContext()
  const [ annual, setAnnual ] = useState(state?.annual)
  const { frequency, layout } = state.texts

  const getPrice = () => {
    return formatNb(
      Number
      .parseFloat(state.price * (annual ? 12 : 1))
      .toFixed(2)
      .replace('.',',')
    ) + (
      annual
        ? ' €/an'
        : ' €/mois'
    )
  }

  const onSubmit = (e) => {
    e.preventDefault()
    nextPage({ pathname, state, navigate, data: { annual } })
    nextPageTransition()
  }

  const activationDate = () => {
    const date = new Date(state.activation)
    date.setDate( date.getDate() + 3 )
    return new Intl.DateTimeFormat('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date)
  }

  return (
    <>
      <h1>{frequency?.title}</h1>
      <div className={style.infos}>
        <span className={style.price}>{getPrice()} TTC</span>
        {frequency?.firstDate.replace('{{date}}', activationDate())}
      </div>

      <form onSubmit={onSubmit}>
        <ul className={style.toggle} onClick={() => setAnnual(!annual)}>
          <li className={annual ? style.selected : undefined}>
            {frequency?.yearly}
          </li>
          <li className={!annual ? style.selected : undefined}>
            {frequency?.monthly}
          </li>
        </ul>

        <Button
          label={<>{layout?.next} <Arrow /></>}
          onClick={onSubmit}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProEstimate